<template>
  <section
    :aria-label="post.title"
    class="a-cover header-padding flex flex-col lg:flex-row bg-primary lg:bg-primary-95 overflow-y-auto"
  >
    <div class="w-full lg:h-full lg:w-1/4 bg-white">
      <div class="flex-a p-x h-10 md:h-12 bg-grey-2">
        <BtnBack
          icon="BackIcon"
          aria="Back"
          text="Back"
          iconsize="1.5rem"
          textsize="base"
          iconcolor="primary"
          textcolor="primary"
          class="font-bold"
        />
      </div>
      <h1
        class="flex-a p-x h-8 md:h-12"
        :class="[`bg-${palette.primary}`, { 'text-white': isGuided }]"
        v-html="title"
      />
      <div class="p-x py-8">
        <h2
          class="font-bold"
          :class="[`border-${palette.primary}`]"
          v-html="post.title"
        />
        <p v-html="post.description" />
      </div>
    </div>

    <div
      class="relative w-full lg:flex-c lg:h-full lg:w-3/4 lg:px-10vw lg:overflow-y-auto"
    >
      <component :is="component" :post="post" />
      <BtnBack
        v-if="!mobile"
        icon="CloseIcon"
        aria="Back"
        :iconsize="mobile ? '2rem' : '2.2rem'"
        iconcolor="white"
        class="absolute top-4 right-3vw md:right-8"
      />
    </div>
  </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { capitalize } from '@/mixins'

import Article from '@/components/Article.vue'
import Gallery from '@/components/Gallery.vue'
import Video from '@/components/Video.vue'
import BtnBack from '@/components/buttons/BtnBack.vue'

export default {
  name: 'Media',

  components: {
    Article,
    Gallery,
    Video,
    BtnBack
  },

  mixins: [capitalize],

  props: {
    location: {
      type: Object,
      default: () => {}
    },
    palette: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    ...mapState(['touch', 'mobile']),
    ...mapGetters(['post', 'getPostBySlug']),

    component() {
      return this.capitalize(this.post.type)
    },

    category() {
      return this.getPostBySlug(this.$route.params.category_id)
    },

    media() {
      return this.getPostBySlug(this.$route.params.media_id)
    },

    isGuided() {
      return this.$route.meta.guided
    },

    title() {
      if (this.isGuided) return this.location.title
      return this.category.title
    },

    isArticle() {
      return this.post.type === 'article'
    }
  }
}
</script>
